module.exports = __webpack_public_path__ + "img/re-result-5.b3896806.jpg";